import { render, staticRenderFns } from "./WikiMenuEdit.vue?vue&type=template&id=b210a6cc"
import script from "./WikiMenuEdit.vue?vue&type=script&lang=ts"
export * from "./WikiMenuEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports